import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INoteData } from '@interfaces/INoteData';
import {
  IStudentFinalResults,
  IStudentGenerateFinalResults,
} from '@interfaces/IStudentResults';
import { IUser } from '@interfaces/IUser';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersChangesService {
  constructor(private _http: HttpClient) {}

  blockStudent(id: number): Observable<IUser> {
    const url = `${environment.baseUrl}api/v1/users/${id}/`;
    return this._http.patch<IUser>(url, { is_active: false });
  }

  activateStudent(id: number): Observable<IUser> {
    const url = `${environment.baseUrl}api/v1/users/${id}/`;
    return this._http.patch<IUser>(url, { is_active: true });
  }

  resetAllStudentsWorks(id: number): Observable<IUser> {
    const url = `${environment.baseUrl}api/v1/users/${id}/reset-reviews/`;
    return this._http.delete<IUser>(url);
  }

  makeNoteAboutStudent(data: INoteData) {
    const url = `${environment.baseUrl}api/v1/notes/`;
    return this._http.post<INoteData>(url, data);
  }

  editNoteAboutStudent(id: number, data: INoteData) {
    const url = `${environment.baseUrl}api/v1/notes/${id}`;
    return this._http.put<INoteData>(url, data);
  }

  deleteUser(id: number): Observable<IUser> {
    const url = `${environment.baseUrl}api/v1/users/${id}/`;
    return this._http.delete<IUser>(url);
  }

  editUser(
    id: number,
    userData: IUser
  ): Observable<{ user: IUser; detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/${id}/`;
    return this._http.patch<{ user: IUser; detail: string }>(url, userData);
  }

  saveStudentResults(
    userId: number,
    data: IStudentGenerateFinalResults
  ): Observable<IStudentFinalResults[]> {
    const url = `${environment.baseUrl}api/v1/result_filter/${userId}/`;
    return this._http.post<IStudentFinalResults[]>(url, {
      result_filter: data,
    });
  }

  deleteStudentResults(resultId: number): Observable<IStudentFinalResults> {
    const url = `${environment.baseUrl}api/v1/result_filter/${resultId}/`;
    return this._http.delete<IStudentFinalResults>(url);
  }

  deleteHappyPoint(group: number, period: number, student: number) {
    const url = `${environment.baseUrl}api/v1/groups/${group}/students/happy-point/`;
    return this._http.delete(url, { body: { period, student } });
  }
}
